export const API_ENDPOINT = 'https://euroexpress.novamedia.agency';
// export const API_ENDPOINT = 'http://localhost:9998';